import { createI18n } from 'vue-i18n'
import enAU from './locales/en-AU.json'

export const DEFAULT_LOCALE = 'en-AU'

export const supportedLocales = [
  {
    code: 'en-AU',
    label: 'English (Australia)',
  },
] as const

export type SupportedLocale = (typeof supportedLocales)[number]['code']

const LOCALE_STORAGE_KEY = 'locale'

export const isSupportedLocale = (locale: string): locale is SupportedLocale => {
  return supportedLocales.some((option) => option.code === locale)
}

export const getInitialLocale = (): SupportedLocale => {
  const storedLocale = localStorage.getItem(LOCALE_STORAGE_KEY)
  if (storedLocale && isSupportedLocale(storedLocale)) return storedLocale

  const browserLocale = navigator.language
  if (isSupportedLocale(browserLocale)) return browserLocale

  return DEFAULT_LOCALE
}

export const persistLocale = (locale: SupportedLocale) => {
  localStorage.setItem(LOCALE_STORAGE_KEY, locale)
  document.documentElement.lang = locale
}

export const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    'en-AU': enAU,
  },
  numberFormats: {
    'en-AU': {
      decimal: {
        style: 'decimal',
      },
      currency: {
        style: 'currency',
        currency: 'AUD',
      },
    },
  },
  datetimeFormats: {
    'en-AU': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
      time: {
        hour: 'numeric',
        minute: '2-digit',
      },
    },
  },
})

export const setI18nLocale = (locale: SupportedLocale) => {
  i18n.global.locale.value = locale
  persistLocale(locale)
}

persistLocale(getInitialLocale())
